<h2>Outils</h2>
<div class="row">
    <div class="col-sm-2">
        <button class="btn btn-info btn-block">Banques</button>
        <button class="btn btn-info btn-block">Rapports d'erreurs</button>
        <button class="btn btn-info btn-block">Stats Routeurs 3G</button>
        <button class="btn btn-info btn-block">Serveur de Tuneling</button>
    </div>
    <div class="col-sm-2">
        <button class="btn btn-info btn-block">Boxes / Modems</button>
        <button class="btn btn-info btn-block">Mises à jour</button>
        <button class="btn btn-info btn-block">Backups</button>
        <button class="btn btn-info btn-block">Synchro APD Server</button>
    </div>
    <div class="col-sm-2"><button class="btn btn-info btn-block">Passerelles IP</button>
    <button class="btn btn-info btn-block">Contrats SAV</button>
    <button class="btn btn-info btn-block">Accounts</button>
    <button class="btn btn-info btn-block">FortiNet</button></div>
    <div class="col-sm-2">
        <button class="btn btn-info btn-block">Roles Personnes</button>
        <button class="btn btn-info btn-block">Profiles</button>
        <button class="btn btn-info btn-block">Statistiques GOP</button>
    </div>
    <div class="col-sm-2">
        <button class="btn btn-info btn-block">Groupes de Personnes</button>
        <button class="btn btn-info btn-block">Gestion des IP interdites</button>
        <button class="btn btn-info btn-block">Gop</button>
    </div>
    <div class="col-sm-2">
        <button class="btn btn-info btn-block">Adresses Emails invalides</button>
        <button class="btn btn-info btn-block">Export Contacts SAV</button>
        <button class="btn btn-info btn-block">Controle consommation</button>
    </div>
</div>
<h2>Actions</h2>
<p><i class="material-icons">pan_tool</i><a href="">Télecollecter toutes les installations Pizza'Door</a></p>
<p><i class="material-icons">pan_tool</i><a href="">Mettre entièrement à jour le serveur externe</a></p>
<h2>Serveur de mise à jour Posware pour Xenteo</h2>
<p><i class="material-icons">pan_tool</i><a href="">Vérifier l'état du serveur</a></p>
<h2>Divers</h2>
<p>
    <i class="material-icons">pan_tool</i>
    <a href="">Décrypter cette valeur de configuration Pizzadoor : </a>
    <input type="text">
</p>
